import { StaticProvider } from '@angular/core';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalGuardConfiguration,
  MsalInterceptorConfiguration,
} from '@azure/msal-angular';
import { InteractionType, IPublicClientApplication, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { ENVIRONMENT, EnvironmentConfig, PROJECT_PREFIX } from '@ct/model';

export function MSALInstanceFactory(env, port: number, prefix: string, devMode = false): IPublicClientApplication {
  const authority = 'https://login.microsoftonline.com/3aa4a235-b6e2-48d5-9195-7fcf05b459b0';
  const redirectUri = devMode
    ? `${env.BASE_URL}:${port}/${prefix}`
    : (env.START_PAGE_URL + prefix).replace(/\/+$/gi, '/');
  return new PublicClientApplication({
    auth: {
      clientId: env.CLIENT_ID,
      authority,
      redirectUri,
      postLogoutRedirectUri: env.START_PAGE_URL,
    },
    cache: {},
    system: {
      loggerOptions: {
        logLevel: LogLevel.Warning,
        piiLoggingEnabled: false,
        loggerCallback(logLevel: LogLevel, message: string) {
          switch (logLevel) {
            case LogLevel.Error:
              console.error(`[MSAL Error]: ${message}`);
              break;
            case LogLevel.Warning:
              console.warn(`[MSAL Warn]: ${message}`);
              break;
            default:
              // tslint:disable-next-line:no-console
              console.info(`[MSAL Info]: ${message}`);
          }
        },
      },
    },
  });
}

export function MSALGuardConfigFactory(env: EnvironmentConfig): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: env.SCOPES ? [env.SCOPES] : [],
    },
  };
}

export function MSALInterceptorConfigFactory(env: EnvironmentConfig): MsalInterceptorConfiguration {
  const scopes = env.SCOPES ? [env.SCOPES] : [];
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: new Map([
      [`/lngct/*`, scopes],
      [`/lpgct/*`, scopes],
      [`/ct/*`, scopes],
      ['/ctintegration/*', scopes],
      ['/dummy/validation', scopes],
    ]),
  };
}

function getLngLpgProviders() {
  return [{ provide: PROJECT_PREFIX, useValue: '' }];
}

export async function bootstrap(
  port = Number(window.location.port),
  prefix = '/',
  devMode = false,
): Promise<StaticProvider[]> {
  const r = await fetch('assets/environment.json');
  const env = await r.json();
  return [
    ...getLngLpgProviders(),
    { provide: ENVIRONMENT, useValue: env },
    { provide: MSAL_INSTANCE, useFactory: () => MSALInstanceFactory(env, port, prefix, devMode) },
    { provide: MSAL_GUARD_CONFIG, useFactory: () => MSALGuardConfigFactory(env) },
    { provide: MSAL_INTERCEPTOR_CONFIG, useFactory: () => MSALInterceptorConfigFactory(env) },
  ];
}
